import type { ReactNode } from 'react';
import Modal from './Modal';
import Button from './Button';

export interface ConfirmDialogProps {
  open: boolean;
  title?: ReactNode;
  /** 확인 문구 */
  message: ReactNode;
  confirmText?: string;
  cancelText?: string;
  /** 위험 동작(삭제 등)이면 확인 버튼을 danger 로 */
  danger?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** 확인/취소 다이얼로그 */
export default function ConfirmDialog({
  open,
  title = '확인',
  message,
  confirmText = '확인',
  cancelText = '취소',
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      title={title}
      onClose={onCancel}
      footer={
        <>
          <Button variant="ghost" onClick={onCancel} disabled={loading}>
            {cancelText}
          </Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>
            {confirmText}
          </Button>
        </>
      }
    >
      <div className="muted">{message}</div>
    </Modal>
  );
}
